export const SET_NOTIFICATIONS = "@NOTIFICATION/SET_NOTIFICATIONS";
export const REQUEST_PUSH_NOTIFICATION = "@NOTIFICATION/REQUEST_PUSH_NOTIFICATION";
export const CLEAR_PUSH_NOTIFICATION = "@NOTIFICATION/CLEAR_PUSH_NOTIFICATION";
export const PUSH_NOTIFICATION = "@NOTIFICATION/PUSH_NOTIFICATION";
export const PUSH_NOTIFICATION_ACTION = "@NOTIFICATION/PUSH_NOTIFICATION_ACTION";
export const SET_NOTIFICATION_PREFERENCES = "@NOTIFICATION/SET_NOTIFICATION_PREFERENCES";
export const SET_IS_NOTIFICATION_REQUESTING = "@NOTIFICATION/SET_IS_NOTIFICATION_REQUESTING";
